import React, { useEffect, useState } from "react";
import matrimonyInstance from "../utils/axios";
import { getDataFromJwt, isUser, replaceIdInUrl } from "../utils/utility";
import { LIST_MY_PROFILES } from "../API_LIST";
import Popup from "../component/section/popup";
import ProfileCard from "../component/section/profileCard";
import EditProfile from "./editProfile";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentProfile } from "../redux/features/authSlice";
import PageTitle from "./pageTitle";

const ProfileDashboard = () => {
	const [profilesData, setProfilesData] = useState();
	const [modalIsOpen, setIsOpen] = useState(false);
	const dispatch = useDispatch();
	const profileSelected = useSelector((state) => state.auth.currentProfile);

	function getProfiles() {
		let userId = getDataFromJwt("id");
		let url = replaceIdInUrl(LIST_MY_PROFILES, userId);
		matrimonyInstance.get(url).then((response) => {
			let objectIs = response.data;
			setProfilesData(objectIs);
		});
	}
	useEffect(() => {
		getProfiles();
	}, []);
	if (
		!profileSelected &&
		profilesData &&
		profilesData.profiles &&
		profilesData.profiles.length
	) {
		dispatch(setCurrentProfile(profilesData.profiles[0]));
	}
	function closeModal() {
		setIsOpen(false);
		getProfiles();
	}

	return (
		<React.Fragment>
			{isUser() ? (
				<div className="d-flex justify-content-between align-items-center pt-25 mr-30 ml-30">
					<h5>Your Profiles</h5>
					{profilesData?.account_verification_status === "approved" ? (
						<span
							onClick={() => setIsOpen(true)}
							className="cursor-pointer create-profile"
						>
							<img
								src="../assets/images/bat-img/add-profile.svg"
								className="add-profile mr-10"
								alt="Add Profile"
							/>
							Create Matrimony Profile
						</span>
					) : (
						<span
							className="not-allowed create-profile-disabled"
							title="Account verification pending"
						>
							<img
								src="../assets/images/bat-img/add-profile.svg"
								className="add-profile mr-10 disabled-icon"
								alt="Add Profile"
							/>
							Create Matrimony Profile
						</span>
					)}
				</div>
			) : null}
			<div className="d-flex justify-content-center pb-30 pt-10">
				<div className="profile-card-list">
					<ProfileCard profilesData={profilesData?.profiles} />
				</div>
			</div>
			<Popup
				modalIsOpen={modalIsOpen}
				closeModal={closeModal}
				html={
					<EditProfile
						profilesData={profilesData}
						setProfilesData={setProfilesData}
						closeModal={closeModal}
					/>
				}
			/>
		</React.Fragment>
	);
};

export default ProfileDashboard;
